module.exports = __webpack_public_path__ + "img/telephone.55580c86.svg";